import gql from 'graphql-tag';

const incapacidadesTiposTableQuery = gql`
    query incapacidades_tipos($numberItems: Int!, $numberPage: Int!, $fieldOrder: String!, $Order: SortOrder!) {
        incapacidades_tipos(first: $numberItems, page: $numberPage, activo: true, orderBy:[{field: $fieldOrder, order: $Order}]) {
            data {
                id,
                nombre
            }
            paginatorInfo {
                count
                currentPage
                firstItem
                lastItem
                hasMorePages
                lastPage
                perPage
                total
            }
        }
    }
`


const queries = { incapacidadesTiposTableQuery };

export default queries;
